import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Button, Card, Col, Form, Input, message, notification, Row, Tag } from 'antd';
import * as CommonService from '../../../services/CommonService';
import { INVOICE_ENDPOINT, INVOICE_REFUND_ENDPOINT } from '../../../services/endpoint';
import FormItem from 'antd/es/form/FormItem';
import TextArea from 'antd/es/input/TextArea';
import RefundProduct from './components/refund-product';
import ReplaceProduct from './components/replace';
import './style.scss';
import InfoRow from '../../../components/common/info-row';
import { currencyVND } from '../../../utils';
import { useHistory } from 'react-router-dom';

const CustomerRefundCreate = (props) => {

	const history = useHistory();

	const [invoiceRefund, setInvoiceRefund] = useState();
	const [products, setProducts] = useState([]);
	const [replaceList, setReplaceList] = useState([]);
	const [totalPriceReplace, setTotalPriceReplace] = useState(0);
	const [invoiceId, setInvoiceId] = useState(null);
	const { getFieldDecorator } = props.form;

	useEffect(() => {
		const id = new URLSearchParams(window.location.search).get('id');
		if (id) {
			setInvoiceId(id);
			window.setLoading(true);
			CommonService.get(`${INVOICE_ENDPOINT}/${id}/refund`).then(res => {
				setInvoiceRefund(res.data);
			}).catch(err => message.error('Có lỗi xảy ra: ' + err?.data?.message.replace(/_/g, ''))).finally(() => window.setLoading(false));
		}
	}, []);

	useEffect(() => {
		if (invoiceRefund) {
			const prdList = invoiceRefund.products.filter(record => (record.imeis ? record.imeis.length : record.quantity) > 0).map(el => ({
				...el,
				refundQuantity: 0,
				isNormal: !el.imeis,
				priceRefund: el.unitPrice - el.discount,
				discount: el.discount || 0,
			}));
			setProducts(prdList);
		}
	}, [invoiceRefund]);

	const totalRefund = useMemo(() => {
		return products.reduce((acc, item) => acc + (item.priceRefund * item.refundQuantity), 0);
	}, [products]);

	const handleSubmit = (e) => {
		e.preventDefault();
		const note = props.form.getFieldValue('note');
		const errMsg = validate();
		if (errMsg) {
			notification.error({ title: 'Lỗi', message: errMsg, duration: 3 });
			return;
		}
		const body = {
			note,
			invoiceId,
			refundProducts: createProductDto(products.filter(el => el.selected)),
			exchangeProducts: replaceList.map(el => ({
				productId: el.id,
				quantity: el.isNormal ? el.countProduct : el.imeiListSelected.length,
				unitPrice: el.retailPrice,
				discount: el.discount || 0,
				imeis: el.isNormal ? null : el.imeiListSelected
			}))
		};
		window.setLoading(true);
		CommonService.create(INVOICE_REFUND_ENDPOINT, body).then(res => {
			if (res) {
				message.success('Tạo đơn hoàn trả thành công');
				history.push('/customer-refund');
			}
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => window.setLoading(false));
	};

	const createProductDto = arr => {
		return arr.map(el => ({
			productId: el.productId,
			quantity: el.refundQuantity,
			unitPrice: el.priceRefund,
			discount: el.discount,
			imeis: el.isNormal ? null : el.imeiListSelected
		}));
	};

	const validate = () => {
		const productSelected = products.filter(el => el.selected);
		if (productSelected.length === 0) {
			return 'Vui lòng chọn sản phẩm cần đổi trả';
		} else if (productSelected.some(el => el.refundQuantity <= 0)) {
			return 'Số lượng sản phẩm hoàn trả phải lớn hơn 0';
		} else if (replaceList.some(el => {
			if (el.isNormal) {
				if (!el?.countProduct || el?.countProduct <= 0)
					return true;
			} else {
				if (!el?.imeiListSelected || el?.imeiListSelected?.length === 0) {
					return true;
				}
			}
		})) {
			return 'Số lượng sản phẩm đổi phải lớn hơn 0';
		}
	};

	return (
		<Fragment>
			{invoiceId ? <Form layout={'vertical'}>
				<Row gutter={12}>
					<Col span={16}>
						<Card title={'Thông tin phiếu'}>
							<Row>
								<Col span={12}>
									<FormItem label={'Khách hàng'} style={{ marginBottom: 0 }}>
										<p><span style={{ color: '#0088FF', cursor: 'pointer' }}
														 onClick={() => window.open('/customer/' + invoiceRefund?.customer?.id)}>{invoiceRefund?.customer?.name}</span> - {invoiceRefund?.customer?.phoneNumber}
										</p>
									</FormItem>
									<FormItem label={'Chi nhánh'} style={{ marginBottom: 0 }}>
										<i>SurfaceCity</i>
									</FormItem>
								</Col>
								<Col span={12}>
									<FormItem label={'Mã đơn gốc'} style={{ marginBottom: 0 }}>
										<p><span style={{ color: '#0088FF', cursor: 'pointer' }}
														 onClick={() => window.open('/orders/' + invoiceRefund?.id)}>{invoiceRefund?.invoiceCode}</span>
										</p>
									</FormItem>
									<FormItem label={'Tham chiếu'} style={{ marginBottom: 0 }}>
										{getFieldDecorator('ref', {})(<Input placeholder="Nhập tham chiếu" />)}
									</FormItem>
								</Col>
							</Row>
						</Card>
					</Col>
					<Col span={8}>
						<Card title={'Thông tin bổ sung'}>
							<FormItem label={'Ghi chú'}>
								{getFieldDecorator('note', {})(<TextArea placeholder="Nhập ghi chú" rows={3} />)}
							</FormItem>
						</Card>
					</Col>
				</Row>
				<Row>
					<RefundProduct products={products}
												 setProducts={setProducts}
												 totalRefund={totalRefund}
					/>
				</Row>
				<Row>
					<ReplaceProduct ds={replaceList} setDs={setReplaceList} form={props.form}
													setTotalPrice={setTotalPriceReplace} />
				</Row>
				<Row>
					<Card title={'Thanh toán'} className={'mt-20'}>
						<InfoRow labelSpan={3} valueSpan={14} label={'Cần hoàn tiền trả hàng'} value={currencyVND(totalRefund)} />
						{/*<InfoRow labelSpan={3} valueSpan={14} label={'Chiết khấu'} value={currencyVND(invoiceRefund?.discountAmount || 0)} />*/}
						<InfoRow labelSpan={3} valueSpan={14} label={'Khách cần trả đơn đổi'}
										 value={currencyVND(totalPriceReplace)} />
						<InfoRow labelSpan={3} valueSpan={14}
										 label={(totalRefund - totalPriceReplace) < 0 ? 'Tổng tiền khách phải trả' : 'Tổng tiền cần hoàn trả khách'}
										 value={<span
											 style={{ color: 'red' }}>{totalRefund > 0 ?(totalRefund - totalPriceReplace) < 0 ? currencyVND(((totalRefund - totalPriceReplace) * -1))
											 : currencyVND((totalRefund - totalPriceReplace)) : '---'}</span>} />
					</Card>
				</Row>
				<Col style={{ textAlign: 'right', marginTop: 10 }}>
					<Button style={{ marginRight: '5px' }} onClick={() => history.push('/customer-refund')}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Tạo đơn đổi trả hàng</Button>
				</Col>
			</Form> : <span>Vui lòng chọn sản phẩm trả từ màn hình <span
				style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
				onClick={() => history.push('/customer-refund')}>Khách hàng trả</span></span>}
		</Fragment>
	);
};
export default Form.create({ name: 'CustomerRefundCreate' })(CustomerRefundCreate);
